module.exports = __webpack_public_path__ + "static/5-6-brochure-pdf-d058962e784d8ba0060739a286eac02e.pdf";